



































import {Component, Vue} from 'vue-property-decorator'
import {Inject} from "typescript-ioc";
import UserApi from "@/api/UserApi";
import {registerWayZh, UserDetail} from "@/model/User";
import userModule from "@/store/module/UserModule";
import SpanNullable from "@/component/Span/span-nullable.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";

@Component({
    components: {
        SpanNullable,
        RefreshButton,
    },
})
export default class UserInfoView extends Vue {

    @Inject
    private userApi!: UserApi

    private leftColSpan = 3
    private rightColSpan = 5

    private user = new UserDetail()

    private registerWayZh = registerWayZh

    private created() {
        this.getUserDetail()
    }

    private refresh() {
        this.getUserDetail()
    }

    private async getUserDetail() {
        const id = String(this.$route.query.id)
        this.user = await this.userApi.detail(id)
        await userModule.activate(this.user)
    }
}
